import * as _Int from '../../settings/interfaces';
import * as preset from "./presetContent";

import * as custom from "../../client/js/custom";

/** Loads pre-defined content (paragraph/statement/image)
 * @param card Page info from settings
 */
export function loadPreset(card: _Int.Path.ICard, currentCardDOM: HTMLElement): void {
   const contentArray: _Int.Path.IContent[] = card.content;
   let contentBox: HTMLDivElement = document.createElement("div");

   contentArray.forEach((content: _Int.Path.IContent) => {

      // render content based on type
      if (content.type === "image") {

         contentBox = preset.renderImage(content.file as string, content.imageDesc as string, contentBox);

      } else if (content.type === "parag" || "p" || "statement") {

         contentBox = preset.renderParagraph(content.text as string, contentBox);

      }
   });

   currentCardDOM.innerHTML = contentBox.outerHTML;
}

/**Loads a custom HTML template page into the html_panel
 */
export function loadCustom(card: _Int.Path.ICard, currentCardDOM: HTMLElement): void {

   const customHTMLPage = require("@/client/html/" + card.content[0].file);

   // load html into placeholder
   currentCardDOM.innerHTML = customHTMLPage;

   // add events to any custom clickables
   const clickables = currentCardDOM.querySelectorAll("[data-click]");

   for (const clickable of clickables) {
      const event = clickable.getAttribute("data-click");
      clickable.addEventListener("click", (custom as any)[event as string]);
   }
}